import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import { previewHistoryBatch } from '../../../../store/extensions';
import BackdropHlsAdjustmentSlider from './BackdropHlsAdjustmentSlider';

const BackdropHlsAdjustmentSaturationListItem = (props) => {
    const { updateBackgroundSettings, maxHlsAdjustmentSaturation, hlsAdjustmentSaturation } = props;
    const onSaturationChange = (value) => {
        previewHistoryBatch.start()
        updateBackgroundSettings({ hlsAdjustment: { saturation: value } });
    }

    return (
        <BackdropHlsAdjustmentSlider
            title='Saturation'
            value={hlsAdjustmentSaturation}
            min={0}
            max={maxHlsAdjustmentSaturation * 100}
            step={0.1}
            onValueChange={onSaturationChange}
            hideArrows
        />
    );
};

const mapStateToProps = (state) => {
    const hlsAdjustmentSaturation = state.createPreview.present.videoSettings.background.hlsAdjustment.saturation;
    const { maxHlsAdjustmentSaturation } = state.create.maxValues;
    return { hlsAdjustmentSaturation, maxHlsAdjustmentSaturation }
}

const mapDispatchToProps = (dispatch) => {
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    return { updateBackgroundSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackdropHlsAdjustmentSaturationListItem);